import { apiFetch, singletonRefresh } from "@/lib/api-client";

interface AuthUserResponse {
  id: string;
  email: string | null;
  displayName: string | null;
  totpEnabled: boolean;
  role: "admin";
}

export const authApi = {
  /** Cookie を受け取るため withCredentials: true */
  login: (json: { loginId: string; password: string; totpCode?: string }) =>
    apiFetch<{
      ok: true;
      accessToken: string;
      expiresIn: number;
      user: AuthUserResponse;
    }>("/api/admin/auth/login", {
      method: "POST",
      json,
      withCredentials: true,
    }),
  passwordSetup: (json: { userId: string; token: string; password: string }) =>
    apiFetch<{ ok: true }>("/api/admin/auth/password-setup", {
      method: "POST",
      json,
    }),
  logout: () =>
    apiFetch<{ ok: true }>("/api/admin/auth/logout", {
      method: "POST",
      withCredentials: true,
    }),
  /** 起動時に Cookie だけで呼ぶサイレントリフレッシュ */
  refresh: () => singletonRefresh(),
  me: () =>
    apiFetch<{
      ok: true;
      user: AuthUserResponse;
    }>("/api/admin/auth/me"),
};
